import { render, staticRenderFns } from "./AddModifierSidebar.vue?vue&type=template&id=41094ca0&scoped=true&"
import script from "./AddModifierSidebar.vue?vue&type=script&lang=js&"
export * from "./AddModifierSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AddModifierSidebar.vue?vue&type=style&index=0&id=41094ca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41094ca0",
  null
  
)

export default component.exports